import axios from 'axios';

const endpoint = process.env.VUE_APP_AWS_INQUIRY_EMAIL_API_ENDPOINT;

const sendInquiryEmail = async (body) => {
  const response = await axios.post(`${endpoint}/inquiry-email`, body);
  return response;
};

const sendDocumentRequest = async (body) => {
  const response = await axios.post(`${endpoint}/document-request`, body);
  return response;
};

const sendContactRequest = async (body) => {
  const response = await axios.post(`${endpoint}/contact`, body);
  return response;
};

export { sendInquiryEmail, sendContactRequest, sendDocumentRequest };
